export const debug = 16;

// Setup global variables
export let CURRENT_GEOTYPE;
export const setCurrentGeoType = (type) => CURRENT_GEOTYPE = type;
export let availableLineAttributes;
export const setAvailableLineAttributes = (a) => availableLineAttributes = a;
export let updSurfaceWithPolyResAttrEntities;
export const setUpdSurfaceWithPolyResAttrEntities =
  (v) => updSurfaceWithPolyResAttrEntities = v;
export let currentLayerId;
export const currentLayer = { id: '', name: '', subgroup: '' };
export const setCurrentLayer = (id, name, subgroup) => {
  currentLayerId = id;
  currentLayer.id = id;
  currentLayer.name = name;
  currentLayer.subgroup = subgroup || '';
};
export let layerStyle;
export const setLayerStyle = (s) => layerStyle = s;
export let isSVGSelected = false;
export const setIsSVGSelected = (b) => isSVGSelected = b;
// export let dateFormatter = 'Y-m-d';
export let currentDataProj = 'EPSG:4258';
export const setCurrentDataProj = (p) => currentDataProj = p;
export let currentDataExtent = [];
export const setCurrentDataExtent = (e) => currentDataExtent = e;
export let highlighted = 0;
export const setHighlighted = (h) => highlighted = h;

// Quality check global variables:
export let userCanEditLayers = true;
export const preventUserFromEditing = () => userCanEditLayers = false;

export const minZoom = 2.9;
export const maxZoom = 18;
export let maxEditResolution = 1000; // it will change for ar5
export const setMaxEditResolution = r => maxEditResolution = r;
export let minDrawingZoom = minZoom; // it will change for ar5
export const setMinDrawingZoom = z => minDrawingZoom = z;

// GUI configuration, specific to Reindrift or AR5, will be loaded here:
export let guiConfiguration;
export const setGuiConfiguration = (c) => guiConfiguration = c;
export let currentToolbarWindow = 'none';
export const setCurrentToolbarWindow = (tab) => currentToolbarWindow = tab;

// Get texts we use in GUI
import i18n_nb from '/config/locales/nb.json'
import i18n_sami from '/config/locales/sami.json'
const i18n_ = { nb: i18n_nb, sami: i18n_sami };
export let i18n = i18n_['nb'];
export const loadLocale = (lang) => i18n = i18n_[lang];

export const codemap = {};

export let itIsAr5 = false;
export const setRemotelyAr5 = (a) => itIsAr5 = a;
export let locallyAr5 = false;
export const setLocallyAr5 = (a) => locallyAr5 = a;

// D3
export let collection;
export const setD3Collection = (c) => collection = c;
export let d3Feature;
export const setD3Feature = (f) => d3Feature = f;
export let path;
export const setD3Path = (p) => path = p;

export let cursorType = ''; // non-loading cursor, we need it when loading stops.
export const setCursorType = (t) => cursorType = t;
